import React, { useState } from 'react';
import { trackCallConversion, trackLeadConversion } from '../../utils/tracking';
import './BookingForm.css';

// --- Icons ---
const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#C98E32" stroke="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const DeviceIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
    <line x1="12" y1="18" x2="12.01" y2="18"></line>
  </svg>
);

const NoteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

const MapPinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A0F00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1A0F00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

const ContactPhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const ContactMailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const ContactMapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

// Trust Bar Icons
const ShieldCheckIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M9 12l2 2 4-4"></path>
  </svg>
);

const TechnicianIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const StarBadgeIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6"></circle>
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"></path>
  </svg>
);

const DoorIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18"></path>
    <path d="M6 21V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v17"></path>
    <circle cx="15" cy="12" r="1"></circle>
  </svg>
);

const BookingForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    device: '',
    issue: '',
    address: '',
    date: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');

    const payload = {
      mobileNumber: formData.phone || '',
      customerName: formData.name || 'Not provided',
      email: formData.email ? formData.email.trim() : null,
      address: formData.address || 'Not provided',
      deviceType: formData.device || 'Other Device',
      brandModel: formData.device || 'General Device',
      issueDescription: formData.issue || 'Not provided',
    };

    try {
      // 1. Submit lead to Vercel API Endpoint
      try {
        const response = await fetch('https://dsmr-api.vercel.app/api/booking', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json().catch(() => null);

        if (!response.ok) {
          console.warn('Vercel API returned non-200:', response.status, data);
        } else {
          console.log('Vercel API Success:', data);
        }
      } catch (apiErr) {
        console.warn('Vercel API network error:', apiErr);
      }

      setSubmitted(true);
      trackLeadConversion({
        mobileNumber: formData.phone,
        email: formData.email,
        device: formData.device,
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        device: '',
        issue: '',
        address: '',
        date: ''
      });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Booking submission error:', error);
      setErrorMessage('Unable to send request. Please try again or reach us on Call/WhatsApp at +91 8700319769.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="booking" className="bys-section">
      {/* Background Ambient Ornaments */}
      <div className="bys-bg-dots bys-bg-dots-left" aria-hidden="true" />
      <div className="bys-bg-dots bys-bg-dots-right" aria-hidden="true" />
      <div className="bys-bg-glow" aria-hidden="true" />

      <div className="bys-container">
        {/* Header */}
        <header className="bys-header">
          <div className="bys-badge">
            <StarIcon />
            <span>BOOK YOUR SERVICE</span>
          </div>

          <h2 className="bys-title">
            <span className="bys-title-main">Book Your</span>
            <span className="bys-title-gold"> Service</span>
          </h2>

          {/* Gold Diamond Divider Ornament */}
          <div className="bys-heading-divider" aria-hidden="true">
            <div className="bys-divider-line" />
            <div className="bys-divider-diamond" />
            <div className="bys-divider-line" />
          </div>

          <p className="bys-subtitle">
            Schedule a doorstep service in just a few clicks.
          </p>
        </header>

        {/* 2-Column Main Content Grid */}
        <div className="bys-main-grid">
          {/* Left Column: Form Card */}
          <div className="bys-form-card">
            {submitted && (
              <div className="bys-success-alert">
                <span>🎉 Booking Request Received! Our team will contact you within 15 minutes.</span>
              </div>
            )}

            {errorMessage && (
              <div className="bys-error-alert">
                <span>⚠️ {errorMessage}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="bys-form">
              {/* Full Name */}
              <div className="bys-field-group">
                <label className="bys-label">Full Name</label>
                <div className="bys-input-wrapper">
                  <span className="bys-input-icon"><UserIcon /></span>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="John Doe"
                    className="bys-input"
                  />
                </div>
              </div>

              {/* Email & Phone Row */}
              <div className="bys-form-row">
                <div className="bys-field-group">
                  <label className="bys-label">Email (optional)</label>
                  <div className="bys-input-wrapper">
                    <span className="bys-input-icon"><MailIcon /></span>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com"
                      className="bys-input"
                    />
                  </div>
                </div>

                <div className="bys-field-group">
                  <label className="bys-label">Phone</label>
                  <div className="bys-input-wrapper">
                    <span className="bys-input-icon"><PhoneIcon /></span>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="+91 8700319769"
                      className="bys-input"
                    />
                  </div>
                </div>
              </div>

              {/* Device Type */}
              <div className="bys-field-group">
                <label className="bys-label">Device Type</label>
                <div className="bys-select-wrapper">
                  <span className="bys-input-icon"><DeviceIcon /></span>
                  <select
                    name="device"
                    value={formData.device}
                    onChange={handleChange}
                    required
                    className="bys-select"
                  >
                    <option value="">Select device type</option>
                    <option value="smartphone">Smartphone / Android</option>
                    <option value="iphone">iPhone</option>
                    <option value="laptop">Laptop</option>
                    <option value="macbook">MacBook</option>
                    <option value="desktop">Desktop / PC</option>
                    <option value="data-recovery">Data Recovery</option>
                    <option value="other">Other Device</option>
                  </select>
                  <span className="bys-select-chevron"><ChevronDownIcon /></span>
                </div>
              </div>

              {/* Issue Description */}
              <div className="bys-field-group">
                <label className="bys-label">Issue Description (optional)</label>
                <div className="bys-textarea-wrapper">
                  <span className="bys-textarea-icon"><NoteIcon /></span>
                  <textarea
                    name="issue"
                    value={formData.issue}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Describe the issue with your device..."
                    className="bys-textarea"
                  ></textarea>
                </div>
              </div>

              {/* Service Address */}
              <div className="bys-field-group">
                <label className="bys-label">Service Address (optional)</label>
                <div className="bys-input-wrapper">
                  <span className="bys-input-icon"><MapPinIcon /></span>
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Enter your address"
                    className="bys-input"
                  />
                </div>
              </div>

              {/* Preferred Date */}
              <div className="bys-field-group">
                <label className="bys-label">Preferred Date (optional)</label>
                <div className="bys-input-wrapper">
                  <span className="bys-input-icon"><CalendarIcon /></span>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className="bys-input bys-date-input"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="bys-submit-btn"
                style={{ opacity: isSubmitting ? 0.75 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
              >
                <CalendarIcon />
                <span>{isSubmitting ? 'Sending Request...' : 'Book Service'}</span>
              </button>
            </form>
          </div>

          {/* Right Column: Quick Contact & What Happens Next */}
          <div className="bys-right-column">
            {/* Quick Contact Card */}
            <div className="bys-card bys-quick-contact-card">
              <h3 className="bys-card-title">Quick Contact</h3>

              <a
                href="https://wa.me/918700319769"
                target="_blank"
                rel="noopener noreferrer"
                className="bys-whatsapp-btn"
              >
                <div className="bys-wa-left">
                  <WhatsAppIcon />
                  <span>Chat on WhatsApp</span>
                </div>
                <ChevronRightIcon />
              </a>

              <div className="bys-contact-list">
                <div className="bys-contact-item">
                  <div className="bys-contact-icon-box">
                    <ContactPhoneIcon />
                  </div>
                  <div className="bys-contact-text">
                    <span className="bys-contact-label">Call Us</span>
                    <a
                      href="tel:+918700319769"
                      className="bys-contact-val"
                      data-dsmr-phone="true"
                      onClick={(e) => trackCallConversion(e, "tel:+918700319769")}
                    >
                      +91 8700319769 DSMR Solutions
                    </a>
                  </div>
                </div>

                <div className="bys-contact-item">
                  <div className="bys-contact-icon-box">
                    <ContactMailIcon />
                  </div>
                  <div className="bys-contact-text">
                    <span className="bys-contact-label">Email</span>
                    <a href="mailto:support@dsmrsolutions.in" className="bys-contact-val">
                      support@dsmrsolutions.in
                    </a>
                  </div>
                </div>

                <div className="bys-contact-item">
                  <div className="bys-contact-icon-box">
                    <ContactMapPinIcon />
                  </div>
                  <div className="bys-contact-text">
                    <span className="bys-contact-label">Service Area</span>
                    <span className="bys-contact-val bys-area-val">
                      Delhi NCR, Greater Noida, Gurugram, Faridabad, Noida
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* What Happens Next Card */}
            <div className="bys-card bys-next-steps-card">
              <h3 className="bys-card-title">What Happens Next?</h3>

              <div className="bys-steps-container">
                {/* Phone Graphic with Shield Badge */}
                <div className="bys-phone-graphic">
                  <img src="/images/services/iphone.webp" alt="iPhone repair" className="bys-phone-img" />
                  <div className="bys-shield-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      <path d="M9 12l2 2 4-4"></path>
                    </svg>
                  </div>
                </div>

                {/* 3 Steps List */}
                <div className="bys-steps-list">
                  <div className="bys-step-item">
                    <div className="bys-step-num">1</div>
                    <div className="bys-step-content">
                      <h4 className="bys-step-title">Confirmation Call</h4>
                      <p className="bys-step-desc">We'll call within 15 minutes to confirm</p>
                    </div>
                  </div>

                  <div className="bys-step-item">
                    <div className="bys-step-num">2</div>
                    <div className="bys-step-content">
                      <h4 className="bys-step-title">Technician Assigned</h4>
                      <p className="bys-step-desc">Expert matched to your device</p>
                    </div>
                  </div>

                  <div className="bys-step-item">
                    <div className="bys-step-num">3</div>
                    <div className="bys-step-content">
                      <h4 className="bys-step-title">Doorstep Service</h4>
                      <p className="bys-step-desc">Service at your convenience</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Trust Guarantee Bar */}
        <div className="bys-trust-bar">
          <div className="bys-trust-item">
            <div className="bys-trust-icon-box">
              <ShieldCheckIcon />
            </div>
            <div className="bys-trust-info">
              <h5 className="bys-trust-title">Genuine Parts</h5>
              <p className="bys-trust-desc">100% Original Parts</p>
            </div>
          </div>

          <div className="bys-trust-item">
            <div className="bys-trust-icon-box">
              <TechnicianIcon />
            </div>
            <div className="bys-trust-info">
              <h5 className="bys-trust-title">Expert Technicians</h5>
              <p className="bys-trust-desc">Certified Professionals</p>
            </div>
          </div>

          <div className="bys-trust-item">
            <div className="bys-trust-icon-box">
              <StarBadgeIcon />
            </div>
            <div className="bys-trust-info">
              <h5 className="bys-trust-title">Warranty Service</h5>
              <p className="bys-trust-desc">Upto 12 Months Warranty</p>
            </div>
          </div>

          <div className="bys-trust-item">
            <div className="bys-trust-icon-box">
              <DoorIcon />
            </div>
            <div className="bys-trust-info">
              <h5 className="bys-trust-title">Doorstep Convenience</h5>
              <p className="bys-trust-desc">We Come to You</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingForm;
